type JSONReplacerReviver = (this: any, key: string, value: any) => any;

const setLocalStorage = <T>(key: string, data: T, throwError = false, replace?: JSONReplacerReviver, space?: string | number) => {
    try {
        window.localStorage.setItem(key, JSON.stringify(data, replace, space));
        return true;
    } catch (error) {
        if (throwError) {
            throw error;
        }
        console.error('setLocalStorage ~ error key: ' + key, error);
        return false;
    }
};

const getLocalStorage = <T>(key: string, throwError = false, reviver?: JSONReplacerReviver) => {
    try {
        const data = window.localStorage.getItem(key);
        if (typeof data === 'string') {
            return JSON.parse(data, reviver) as T;
        }
        return data;
    } catch (error) {
        if (throwError) {
            throw error;
        }
        console.error('getLocalStorage ~ error key: ' + key, error);
        return null;
    }
};

export type CreateAppLocalStorageConfig = {
    prefix: string;
    seperator?: string;
    suffix?: string;
    replacer?: JSONReplacerReviver;
    reviver?: JSONReplacerReviver;
};

export const createAppLocalStorage = ({ prefix, seperator = '-', suffix = '', replacer, reviver }: CreateAppLocalStorageConfig) => {
    const getAppLocalStorageKey = (key?: string) => {
        if (typeof key !== 'string') {
            throw new TypeError(`Cannot access localStorage without a key as a string. Recieved: ${key}`);
        }
        if (!key.length) {
            throw new Error('Cannot access localStorage with an empty string as key');
        }
        return prefix + seperator + key + suffix;
    };
    const appGetLocalStorage: typeof getLocalStorage = (key, throwError, _reviver) => {
        return getLocalStorage(getAppLocalStorageKey(key), throwError, _reviver || reviver);
    };
    const appSetLocalStorage: typeof setLocalStorage = (key, data, throwError, _replacer) => {
        return setLocalStorage(getAppLocalStorageKey(key), data, throwError, _replacer || replacer);
    };
    return [appGetLocalStorage, appSetLocalStorage, getAppLocalStorageKey] as const;
};
